<template>
  <div>
    <v-app-bar
      flat
      app
      extended
      hide-on-scroll
      height="100"
      extension-height="70"
      scroll-threshold="40"
      class="px-xs-2 px-2 page-app-bar"
    >
      <app-bar-nav-icon />
      <v-toolbar-title class="pl-0 pl-lg-5 page-title primary--text">
        Users
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-slot:extension>
        <v-row no-gutters class="flex">
          <v-col
            class="d-flex align-center justify-start flex-grow-1 flex-shrink-0"
          >
            <div class="px-6">
              <v-btn
                rounded
                depressed
                :to="{ name: 'users.all' }"
                class="text-capitalize mr-5"
                >All</v-btn
              >
              <v-btn
                rounded
                depressed
                :to="{ name: 'users.onboarding' }"
                class="text-capitalize mr-5"
                >Newly Registered</v-btn
              >
              <v-btn
                rounded
                depressed
                :to="{ name: 'users.unverified' }"
                class="text-capitalize mr-5"
                >Unverified</v-btn
              >
              <v-btn
                rounded
                depressed
                :to="{ name: 'users.verified' }"
                class="text-capitalize mr-5"
              >
                Verified
              </v-btn>
            </div>
          </v-col>

          <v-col
            cols="4"
            class="d-flex align-center justify-start flex-grow-1 flex-shrink-0"
          >
            <div style="width: 100%">
              <v-text-field
                filled
                flat
                solo
                rounded
                clearable
                hide-details
                @input="search"
                label="Search by name"
                v-model="filter.search"
                class="search-form compact-form"
              >
                <template v-slot:prepend-inner>
                  <img class="mr-2" src="@/assets/icons/search.svg" alt="" />
                </template>
              </v-text-field>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-app-bar>

    <div class="px-8 pb-12 mb-12 mt-0">
      <transition name="fade" mode="out-in">
        <router-view :is-searching="loading" :search-key="filter.search" />
      </transition>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import { mapMutations, mapActions } from 'vuex'

export default {
  name: 'UsersPage',

  components: { AppBarNavIcon },

  data() {
    return {
      loading: false,
      filter: {
        search: null
      }
    }
  },

  computed: {
    userType() {
      return this.$route.name.split('.')[1]
    }
  },

  methods: {
    ...mapActions({
      getUsers: 'user/getUsers'
    }),

    ...mapMutations({
      clearUsers: 'user/clearUserList'
    }),

    search: debounce(function() {
      this.clearUsers(this.userType)
      this.fetchUsers()
    }, 600),

    async fetchUsers(page = 1) {
      if (this.loading) return

      let params = { page }

      params.filter = {
        search: this.filter.search,
        type: this.userType
      }

      this.loading = true
      await this.getUsers(params)
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.page-app-bar {
  border-bottom: 1px solid#eee !important;
}
</style>
